<template>
    <div v-if="!loading">
        <div v-if="selectEnvio">
            <div class="row justify-content-center">
                <div :class="!esMovil ? 'd-flex justify-content-center col-12 col-md-8' : 'col-12 col-md-8 text-center'">
                    <input class="mr-2" type="text" v-model="search" placeholder="Search">
                    <b-form-select class="mt-4 mr-2" v-model="selected" :options="options"></b-form-select>
                    <button class="button mt-2" @click="changeInvitaciones">{{isInvitaciones ? $t('perfil.pedidos')  :  $t('perfil.invitaciones_recibidas')}}</button>
                </div>
                <div class="col-12 col-md-8 mt-4" v-if="!isInvitaciones">
                    <ul class="list-group list-group-flush">
                        <template v-if="pedidos.length > 0">
                            <PedidoDetalle 
                                v-for="pedido in pedidos"
                                :key="pedido.id" 
                                :esMovil="esMovil" 
                                :pedido="pedido" 
                                @actualizar="getPedidos" 
                                @enviar="EnviarEntradas"
                            />     
                        </template>
                        <li class="list-group-item text-center" v-else>
                            <h3>
                                {{ $t('perfil.no_pedidos') }}
                            </h3>
                        </li>                    
                    </ul>
                </div>
                <div class="col-12 col-md-8 mt-4" v-else>
                    <ul class="list-group list-group-flush">
                        <template v-if="invitacionesPedidos.length > 0">
                            <template  v-for="pedido in invitacionesPedidos">
                                <InvitacionesDetalle :key="pedido.id" :esMovil="esMovil" :pedido="pedido" @actualizar="getPedidos" @enviar="EnviarEntradas"></InvitacionesDetalle>                
                            </template>    
                        </template>
                        <li class="list-group-item text-center" v-else>
                            <h3>
                                {{ $t('perfil.no_pedidos') }}
                            </h3>
                        </li>                    
                    </ul>
                </div>
                <div class="col-12 col-md-8">
                    <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                    ></b-pagination>
                </div>
            </div>
        </div>
        <div v-else>
            <Envio :pedido="selectedPedido" @atras="atras"></Envio>
        </div>
    </div>
    <div style="padding: 50px;" v-else>
        <LoaderComponent></LoaderComponent>
    </div>
</template>

<script>
import PedidoDetalle from '@/components/frontend/perfil/PedidoDetalle';
import Envio from '@/components/frontend/perfil/pedido/Envio';
import InvitacionesDetalle from '@/components/frontend/perfil/InvitacionesDetalle';

export default {
    data() {
        return {
            currentPage: 1,
            perPage: 10,
            rows: 1,
            pedidos: [],
            search: '',
            selected: 'actuales',
            options: [
                { value: 'actuales', text: 'Actuales' },
                { value: 'pasados', text: 'Pasados' }
            ],
            selectEnvio: true,
            selectedPedido: null,
            isInvitaciones: false,
            invitacionesPedidos: [],
            esMovil: false,
            loading: false
        }
    },
    created() {
        this.getPedidos();
        this.debouncedGetPedidos = _.debounce(this.getPedidos, 500);
        this.debouncedGetInvitaciones = _.debounce(this.getInvitaciones, 500);
    },
    methods: {
        getPedidos() {
            this.loading = true;

            const data = {
                filters: {
                    page: this.currentPage,
                    per_page: this.perPage,
                    search : this.search,
                    tipo : this.selected
                },
            }

            this.$store.dispatch(this.config.getVuexAlias('front.perfil.pedidos'), data).then(res => {
                this.pedidos = res.data.data;
                this.current_page = res.data.meta.current_page;
                this.per_page = res.data.meta.per_page;
                this.rows = res.data.meta.total;
                this.loading = false;
            });
        },
        getInvitaciones(){
            this.loading = true;

            const data = {
                filters: {
                    page: this.currentPage,
                    per_page: this.perPage,
                    search : this.search,
                    tipo : this.selected
                },
            }

            this.$store.dispatch(this.config.getVuexAlias('front.perfil.invitaciones'), data).then(res => {
                this.invitacionesPedidos = res.data.data;
                this.current_page = res.data.meta.current_page;
                this.per_page = res.data.meta.per_page;
                this.rows = res.data.meta.total;
                this.loading = false;
            });

        },
        EnviarEntradas(pedido){
            this.selectedPedido = pedido;
            this.selectEnvio = false;
        },
        atras(){
            this.selectEnvio = true;
            this.selectedPedido = null;
            this.getPedidos();
        },
        changeInvitaciones(){
            this.isInvitaciones = !this.isInvitaciones;
            this.get();
        },
        get(){
            if(this.isInvitaciones){
                this.debouncedGetInvitaciones();
            }else{
                this.debouncedGetPedidos();
            }
        },
        onResize() {
            this.esMovil = window.innerWidth < 768
        }
    },
    watch : {
        search() {
            this.get();
        },
        selected() {
            this.get();
        },
        currentPage() {
            this.get();
        }
    },
    beforeDestroy() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', this.onResize, { passive: true })
        }
    },
    mounted() {
        this.onResize()
        window.addEventListener('resize', this.onResize, { passive: true })
    },
    components: {
        PedidoDetalle, Envio, InvitacionesDetalle
    }
}
</script>
